module.exports = __webpack_public_path__ + "img/subscribe.0052b3e2.jpg";